















































import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop, Vue} from 'vue-property-decorator';

import {IpMode} from '@/model/network/IpMode';
import {ProfileSettings} from '@/model/network/settings/ProfileSettings';

import {BaseComponent} from '@/mixins/BaseComponent';
import NetworkIpSettingsEditor from '@/components/Networking/Profile/NetworkIpSettingsEditor.vue';
import NetworkConnectRetryEditor from '@/components/Networking/Profile/NetworkConnectRetryEditor.vue';
import NetworkIpTabs from '@/components/Networking/Profile/NetworkIpTabs.vue';
import NetworkIpSettingsRoutesEditor from '@/components/Networking/Profile/NetworkIpSettingsRoutesEditor.vue';

@Component({
  components: {
    NetworkIpSettingsRoutesEditor,
    NetworkIpTabs,
    NetworkConnectRetryEditor,
    NetworkIpSettingsEditor,
  },
})
export default class NetworkEthernetSettingsEditor extends Mixins<BaseComponent>(BaseComponent) {
  @Prop()
  private settings!: ProfileSettings;

  private IpMode = IpMode;

  private nameRules = [
    (value: any) => !!value || 'Required',
    (value: any) => value.length >= 2 || 'Must be 2 chars long at least',
  ];

  public validate(): boolean {
    return (this.$refs.routesEditor as Vue & { validate: () => boolean }).validate();
  }
}
